module.exports = __webpack_public_path__ + "img/Frequency24GHzV2-gray.982e8766.svg";